export enum SectionIds {
  ConversationHub = 101,
  DooryDashboard = 102,
  Communication = 103,
  ConciergeDashboard = 95,
  Persone = 13,
  Preventivi = 51,
  PreventiviMice = 75,
}
